export default {
  data () {
    return {
      // convert url path  to api path
      baseActionObject: {
        '/tournament': '/tournaments',
        '/reporting/article': '/live/posts',
        '/live/reporting': '/live/reportings',
        '/market/article': '/feeds',
        '/article/editor': '/members',
        '/article': '/posts',
      }
    }
  },
  mounted () {
    const lang = this.getCookie('lang')
    const fromLang = this.getQueryParamPath ? this.getQueryParamPath['lang'] : ''
    if (lang !== 'null' && lang && fromLang && lang.toString().toLowerCase() !== fromLang) {
      this.gotoSite(lang)
    } else if (lang === 'null' || !lang) {
      // this.gotoLanding()
      this.gotoSite('EN')
    }
  },
  computed: {
    getCookieLang () {
      return this.getCookie('lang')
    },
    getQueryParamPath () {
      let path = '', lang = ''
      path = window.location.pathname
      if (path) {
        lang = path.slice(0, 4) === '/jp/' || path.slice(0, 4) === '/en/' ? path.slice(1, 3) : 'kr'
        path = path && (path.slice(0, 4) === '/jp/' || path.slice(0, 4) === '/en/') ? path.slice(3) : path ? path : ''
      }
      return {
        path: path,
        lang: lang
      }

    }
  },
  methods: {
    getCookie(key) {
      // 쿠키 값 가져오기
      return this.$cookies.get(key);
    },
    async setLanguageCookie(lang) {
      // 설정 후 페이지를 새로 고침하거나, 필요에 따라 추가 작업 수행
      const host = window.location.hostname.toString()
      await this.$cookies.set('lang', lang, '365d', '/', host)
    },
    async removeLanguageCookie() {
      const host = window.location.hostname.toString()
      await this.$cookies.remove('lang', '/', host)
    },
    removeCookie() {
      this.removeLanguageCookie()
      window.location.reload()
    },
    async gotoSitePage(lang) {
      const toLang = lang.toString().toLowerCase()
      const host = window.location.origin.toString()
      const api = window.location.origin.toString().replace('www.', 'api.')
      const dir = (lang !== 'KR' ? '/' + toLang : '')
      const domain = host + dir
      const path = this.getQueryParamPath['path']
      const fromLang = this.getQueryParamPath['lang']

      const rtn = this.findBaseActionInSiblings(path)
      const baseAction = rtn['baseAction']
      const staticPath = rtn['path']
      const idx = rtn['idx']

      let url
      if (idx && baseAction) {
        const krApiURL = api + ':8080/v1'
        // const krApiURL = 'http://localhost:8280/v1'
        const params = {
          params: {
            base_action: baseAction,
          }
        }
        let rtnIdx
        if (fromLang !== toLang) {
          if (fromLang === 'kr') {
            params.params.model_idx = idx
          } else {
            params.params.mapping_idx = idx
          }
          params.params.lang_code = toLang
          params.params.from_lang_code = fromLang
          rtnIdx = await this.axios.get(krApiURL + '/multi/lang/search', params).then(rs => {
            if (rs.data.mapping_idx) {
              return toLang === 'kr' ? rs.data.model_idx : rs.data.mapping_idx
            }
            return null
          })
          if (rtnIdx) {
            url = domain + staticPath + '/' + rtnIdx
          } else {

            //notice - 주석을 풀면 사용자가 이동을 선택할 수 있음
            // const langArr = {
            //   kr: '한국어',
            //   jp: '일본어',
            //   en: '영어',
            // }
            // if (!confirm(`선택한 언어로는 동일한 컨텐츠가 없습니다. ${langArr[toLang]} 홈으로 이동할까요?`)) {
            //   return
            // }
          }
        } else {
          url = domain + path
        }
      } else {
        url = domain + path
      }
      // console.log(url ? url : domain + '/home')
      window.location = url ? url : domain + '/home'
    },
    async gotoSite(lang) {
      await this.removeLanguageCookie()
      await this.setLanguageCookie(lang)
      await this.gotoSitePage(lang)
    },
    gotoLanding() {
      const host = window.location.origin.toString()
      if (host.indexOf('//localhost') > -1) return
      let domain
      if (host.indexOf('//m.') > -1) {
        domain = host.replace('m.', 'landing.')
      } else {
        domain = host.replace('www.', 'landing.')
      }
      window.location = domain + `?path=/${this.getQueryParamPath['lang']}${this.getQueryParamPath['path']}`
    },
    findBaseActionInSiblings(path) {
      if (!path) {
        return {baseAction: '', path: '', idx: ''}
      }
      const basePath = path.split('?')[0];  // 쿼리 매개변수 제거
      const pathSegments = basePath.split('/').filter(Boolean);  // 경로를 '/'로 분리하고, 빈 문자열 제거

      const staticParts = [];
      const params = [];

      pathSegments.forEach(segment => {
        if (/^\d+$/.test(segment)) {  // 세그먼트가 숫자만으로 구성되어 있는지 확인
          params.push(segment);
        } else {
          staticParts.push(segment);
        }
      });

      const staticPath = '/' + staticParts.join('/')  // 정적 경로 재조합
      const baseAction = this.baseActionObject[staticPath]
      const idx = params[0]  // 파라미터 배열

      return {
        baseAction: baseAction,
        path: staticPath,
        idx: idx
      }
    }
  }
}
